/** Builds the shared grouped-control CSS classes for a consumer; empty when not grouped. */
export function getGroupedControlClassNames(styles, { position, direction, hasAction }) {
    if (!position) {
        return [];
    }
    const classNames = [styles.grouped, styles[`grouped-${direction}-${position}`]];
    // Square the corners facing a fused action so it owns the only rounded inline-end corners.
    if (hasAction) {
        classNames.push(styles[`grouped-end-action-${direction}-${position}`]);
    }
    return classNames;
}
//# sourceMappingURL=grouped-control-styles.js.map